import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createSlots as _createSlots, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  style: {"z-index":"59"},
  class: "absolute top-0 left-0 items-center w-full h-full"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"100% !important","height":"100% !important"},
  class: "absolute z-10 flex w-full h-full transition-none bg-gray-900 rounded opacity-40"
}, null, -1)
const _hoisted_4 = { class: "sticky z-50 mx-auto mt-40 mb-40 text-center rounded -translate-y-3/4 md:top-1/4 md:w-max" }
const _hoisted_5 = {
  style: {"font-size":"10rem"},
  class: "opacity-50 material-icons-outlined text-lightText"
}
const _hoisted_6 = {
  key: 0,
  style: {"padding-top":"1px"},
  class: "flex items-center mb-8"
}
const _hoisted_7 = { class: "pt-2" }
const _hoisted_8 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_9 = {
  key: 1,
  class: "flex"
}
const _hoisted_10 = { class: "flex space-x-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-base material-icons" }, " delete ", -1)
const _hoisted_12 = {
  key: 0,
  style: {"box-shadow":"0px 15px 15px -15px rgb(0 0 0 / 20%)"},
  class: "sticky z-50 flex items-start h-20 py-4 -mx-5 space-x-2 bg-white top-14 align-center"
}
const _hoisted_13 = { class: "flex mx-auto space-x-2" }
const _hoisted_14 = { class: "mt-3 text-muted" }
const _hoisted_15 = { class: "ml-auto w-96" }
const _hoisted_16 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_17 = {
  key: 0,
  class: "flex flex-col items-start my-4 space-y-6 lg:space-x-8 lg:space-y-0 lg:flex-row"
}
const _hoisted_18 = {
  key: 0,
  class: "w-full mt-0.5 mr-auto lg:w-4/12"
}
const _hoisted_19 = { class: "flex space-x-1" }
const _hoisted_20 = {
  key: 1,
  class: "self-start w-full mr-auto lg:w-3/12"
}
const _hoisted_21 = { class: "flex flex-col my-6 space-y-4 xl:flex-row xl:space-x-2 xl:space-y-0" }
const _hoisted_22 = { class: "error-msg" }
const _hoisted_23 = {
  key: 1,
  class: "relative w-full"
}
const _hoisted_24 = { class: "absolute top-2 left-1.5 origin-0 fixed-label w-full" }
const _hoisted_25 = {
  key: 1,
  class: "flex items-start w-full mb-8 space-y-1 md:space-y-0"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1.5 text-base material-icons-outlined" }, " add ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1.5 text-base material-icons-outlined" }, " edit ", -1)
const _hoisted_28 = { class: "flex items-start ml-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1.25px material-icons-outlined inline-icon text-muted" }, "info", -1)
const _hoisted_30 = { class: "ml-1.5 text-sm text-muted" }
const _hoisted_31 = {
  key: 2,
  class: "mb-12"
}
const _hoisted_32 = { class: "mb-4" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  class: "relative w-full"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 mr-1 text-base material-icons-outlined" }, " science ", -1)
const _hoisted_36 = { class: "flex items-center p-3 pl-4 space-x-2 rounded-tr-sm bg-light" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "my-auto material-icons-outlined icon-light" }, " code ", -1)
const _hoisted_38 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "mx-auto mt-24 opacity-30 text-8xl material-icons-outlined" }, " code ", -1)
const _hoisted_40 = { class: "px-4 mx-auto text-muted" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "delete", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base material-icons-outlined" }, " add ", -1)
const _hoisted_43 = {
  key: 3,
  class: "pb-4 mb-6"
}
const _hoisted_44 = {
  class: "mb-1 ml-1 text-primary",
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M3,3H21V21H3V3M13.71,17.86C14.21,18.84 15.22,19.59 16.8,19.59C18.4,19.59 19.6,18.76 19.6,17.23C19.6,15.82 18.79,15.19 17.35,14.57L16.93,14.39C16.2,14.08 15.89,13.87 15.89,13.37C15.89,12.96 16.2,12.64 16.7,12.64C17.18,12.64 17.5,12.85 17.79,13.37L19.1,12.5C18.55,11.54 17.77,11.17 16.7,11.17C15.19,11.17 14.22,12.13 14.22,13.4C14.22,14.78 15.03,15.43 16.25,15.95L16.67,16.13C17.45,16.47 17.91,16.68 17.91,17.26C17.91,17.74 17.46,18.09 16.76,18.09C15.93,18.09 15.45,17.66 15.09,17.06L13.71,17.86M13,11.25H8V12.75H9.5V20H11.25V12.75H13V11.25Z"
}, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = {
  key: 4,
  class: "mb-6"
}
const _hoisted_48 = { class: "flex space-x-1" }
const _hoisted_49 = { key: 5 }
const _hoisted_50 = { class: "flex space-x-1" }
const _hoisted_51 = {
  key: 2,
  class: "mt-6"
}
const _hoisted_52 = { class: "flex mt-1 space-x-1" }
const _hoisted_53 = { class: "mb-6" }
const _hoisted_54 = {
  key: 0,
  class: "mb-4 -mt-4"
}
const _hoisted_55 = { class: "error-msg" }
const _hoisted_56 = {
  key: 1,
  class: "mb-8 -mt-4 banner banner-danger"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "warning", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base material-icons-outlined" }, " add ", -1)
const _hoisted_59 = {
  key: 4,
  class: "mt-8"
}
const _hoisted_60 = { class: "mb-8" }
const _hoisted_61 = {
  key: 0,
  class: "mb-4 -mt-4"
}
const _hoisted_62 = { class: "error-msg" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base material-icons-outlined" }, " add ", -1)
const _hoisted_64 = {
  key: 5,
  class: "mt-8"
}
const _hoisted_65 = { class: "mb-8" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { class: "mb-2 text-muted" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  href: "https://nodejs.org/api/assert.html",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("pre", { class: "inline text-sm" }, "assert"),
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined ml-0.5 inline-icon" }, " open_in_new ")
], -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base material-icons-outlined" }, " add ", -1)
const _hoisted_70 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_71 = { class: "list-disc list-inside" }
const _hoisted_72 = { class: "flex w-full mt-10" }
const _hoisted_73 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_74 = { class: "ml-2" }
const _hoisted_75 = { class: "text-lg text-muted" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl icon-light material-icons-outlined" }, " copy_all ", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl text-danger-dark material-icons-outlined" }, " delete ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloudSaveStatus = _resolveComponent("CloudSaveStatus")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_ClozeExercise = _resolveComponent("ClozeExercise")!
  const _component_CodeExecutionResults = _resolveComponent("CodeExecutionResults")!
  const _component_CodeEditor = _resolveComponent("CodeEditor")!
  const _component_SlotSkeleton = _resolveComponent("SlotSkeleton")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_TagInput = _resolveComponent("TagInput")!
  const _component_ArticleHandle = _resolveComponent("ArticleHandle")!
  const _component_ChoiceEditor = _resolveComponent("ChoiceEditor")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_ExerciseEditor = _resolveComponent("ExerciseEditor", true)!
  const _component_TestCaseEditor = _resolveComponent("TestCaseEditor")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade-delay" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.exerciseLocked ? "lock" : "lock_open"), 1),
            _createElementVNode("h3", {
              class: _normalizeClass([[!_ctx.exerciseLocked ? 'opacity-0' : 'opacity-100'], "pt-1 mx-auto rounded-t md:bg-transparent text-lightText"]),
              style: {"text-shadow":"0.5px 0.5px 4px rgb(0 0 0 / 50%)"}
            }, _toDisplayString(_ctx.$t("exercise_editor.currently_locked_by")) + " " + _toDisplayString(_ctx.modelValue?.locked_by?.full_name), 3),
            _createElementVNode("p", {
              class: _normalizeClass([[!_ctx.exerciseLocked ? 'opacity-0' : 'opacity-100'], "pb-1 rounded-b md:bg-transparent text-lightText md:mx-2 md:px-2"]),
              style: {"text-shadow":"0.5px 0.5px 4px rgb(0 0 0 / 50%)"}
            }, _toDisplayString(_ctx.$t("event_editor.lock_stand_by")), 3)
          ])
        ], 512), [
          [_vShow, _ctx.exerciseLocked]
        ])
      ]),
      _: 1
    }),
    (false && _ctx.modelValue.state !== _ctx.ExerciseState.DRAFT && _ctx.preventEdit)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFocusNonDraft && _ctx.onFocusNonDraft(...args))),
          style: {"z-index":"20"},
          class: "absolute top-0 left-0 w-full h-full bg-gray-500 bg-opacity-0 cursor-pointer"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Card, {
      loading: _ctx.fetchingExercise,
      focusable: !_ctx.subExercise,
      hoverable: false,
      borderLess: _ctx.subExercise,
      filled: _ctx.subExercise,
      class: _normalizeClass({
				'bg-gray-50': false && _ctx.modelValue.state === _ctx.ExerciseState.DRAFT,
				'mb-6': _ctx.subExercise,
				'transition-shadow duration-100 focus-within-shadow-elevation-2': !_ctx.subExercise,
			})
    }, {
      header: _withCtx(() => [
        (!_ctx.subExercise)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("h3", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.exercise_editor_title")) + " ", 1),
                (_ctx.modelValue.state === _ctx.ExerciseState.DRAFT)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "(" + _toDisplayString(_ctx.$t("exercise_editor.draft_notice")) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_CloudSaveStatus, {
                class: "mt-1 ml-auto mr-1",
                saving: _ctx.saving,
                hadError: _ctx.savingError
              }, null, 8, ["saving", "hadError"]),
              _createVNode(_component_Btn, {
                size: 'lg',
                variant: 'icon',
                tooltip: _ctx.$t('misc.close'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["transition-transform duration-200 ease-out transform material-icons-outlined", { 'rotate-180': false && _ctx.showEditor }])
                  }, " close ", 2)
                ]),
                _: 1
              }, 8, ["tooltip"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", {
                class: _normalizeClass(["w-1/5 mt-3", { 'mb-8': _ctx.cloze }])
              }, [
                _createVNode(_component_NumberInput, {
                  max: 100,
                  min: 0,
                  modelValue: _ctx.modelValue.child_weight,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.onBaseExerciseChange('child_weight', $event))),
                  class: "w-full"
                }, _createSlots({
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("exercise_editor.sub_exercise_weight")), 1),
                      _createVNode(_component_Tooltip, {
                        class: "transform scale-125",
                        "text-code": 'exercise_editor.sub_exercise_weight'
                      }, null, 8, ["text-code"])
                    ])
                  ]),
                  _: 2
                }, [
                  (_ctx.invalidChildWeight)
                    ? {
                        name: "errors",
                        fn: _withCtx(() => [
                          _createTextVNode("   ")
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue"])
              ], 2),
              (!_ctx.cloze)
                ? (_openBlock(), _createBlock(_component_Btn, {
                    key: 0,
                    outline: true,
                    variant: 'icon',
                    tooltip: _ctx.$t('exercise_editor.delete_sub_exercise'),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('delete'))),
                    class: "ml-auto -mt-1 -mr-2.5 transition-opacity duration-100 opacity-50 hover:opacity-100"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["tooltip"]))
                : _createCommentVNode("", true)
            ]))
      ]),
      body: _withCtx(() => [
        false
          ? (_openBlock(), _createBlock(_Transition, {
              key: 0,
              name: "fade"
            }, {
              default: _withCtx(() => [
                (_ctx.showStickyStateDropdown)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("exercise_editor.exercise_state")), 1),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_Dropdown, {
                            id: _ctx.stateDropdownId + '-sticky',
                            options: _ctx.exerciseStateOptions,
                            modelValue: _ctx.modelValue.state,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.onExerciseStateChange($event)))
                          }, null, 8, ["id", "options", "modelValue"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.subExercise || !_ctx.cloze)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (!_ctx.subExercise || !_ctx.cloze)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (!_ctx.subExercise)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_TextInput, {
                            modelValue: _ctx.modelValue.label,
                            fixedLabel: true,
                            placeholder: _ctx.$t('exercise_preview.unnamed_exercise'),
                            onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onBlur())),
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.onBaseExerciseChange('label', $event)))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t("exercise_editor.exercise_label")), 1),
                                _createVNode(_component_Tooltip, {
                                  class: "transform scale-125",
                                  "text-code": 'exercise_editor.label'
                                }, null, 8, ["text-code"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.subExercise)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createVNode(_component_Dropdown, {
                            id: _ctx.stateDropdownId,
                            options: _ctx.exerciseStateOptions,
                            modelValue: _ctx.modelValue.state,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.onExerciseStateChange($event)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.exercise_state")), 1)
                            ]),
                            _: 1
                          }, 8, ["id", "options", "modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.cloze)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: _normalizeClass([{ 'md:ml-auto': !_ctx.subExercise }, "flex flex-col w-full md:flex-row lg:w-5/12"])
                        }, [
                          _createVNode(_component_Dropdown, {
                            class: "w-full",
                            id: 'exercise_type_' + _ctx.elementId,
                            options: _ctx.exerciseTypeOptions,
                            modelValue: _ctx.modelValue.exercise_type,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.onExerciseTypeChange($event)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.exercise_type")), 1)
                            ]),
                            _: 1
                          }, 8, ["id", "options", "modelValue"])
                        ], 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                (!_ctx.cloze)
                  ? (_openBlock(), _createBlock(_component_TextEditor, {
                      key: 0,
                      modelValue: _ctx.modelValue.text,
                      onReady: _cache[9] || (_cache[9] = ($event: any) => (_ctx.textEditorInstance = $event)),
                      onSelectionChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onTextSelectionChange($event))),
                      onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onBlur())),
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.onBaseExerciseChange('text', $event))),
                      class: "w-full"
                    }, _createSlots({
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.exercise_text")) + " ", 1)
                      ]),
                      _: 2
                    }, [
                      (_ctx.v$.modelValue.text.$errors.length > 0)
                        ? {
                            name: "errors",
                            fn: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.modelValue.text.$errors, (error) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "input-errors",
                                  key: error.$uid
                                }, [
                                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("validation_errors.exercise." + error.$uid)), 1)
                                ]))
                              }), 128))
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.modelValue.exercise_type === _ctx.ExerciseType.COMPLETION)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("misc.preview")), 1),
                      _createVNode(_component_ClozeExercise, { slot: _ctx.modelValueWrapperSlot }, null, 8, ["slot"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.modelValue.exercise_type === _ctx.ExerciseType.COMPLETION)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createVNode(_component_Btn, {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onAddCloze())),
                      loading: _ctx.addingCloze,
                      variant: 'secondary',
                      class: "w-1/2 2xl:w-1/3"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_26,
                        _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.new_cloze")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_Btn, {
                      outline: true,
                      disabled: _ctx.editableClozeSubExerciseId === null,
                      class: "w-1/2 ml-2 mr-auto 2xl:w-1/3",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.editingClozeSubExerciseId = _ctx.editableClozeSubExerciseId))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27,
                        _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.edit_cloze")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("help_texts.exercise_editor.clozes")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.cloze)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.$t("exercise_editor.solutions_title")), 1),
                    (!_ctx.loadingSolutions)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solutions, (solution) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'e-' + _ctx.modelValue.id + '-sol-' + solution.id,
                              class: "flex my-2 space-x-2"
                            }, [
                              (!_ctx.cloze && !_ctx.isProgrammingExercise)
                                ? (_openBlock(), _createBlock(_component_TextEditor, {
                                    key: 0,
                                    class: "w-full",
                                    modelValue: solution.content,
                                    onBlur: ($event: any) => (_ctx.onBlurSolution(solution.id)),
                                    "onUpdate:modelValue": ($event: any) => (_ctx.onUpdateSolution(solution.id, 'content', $event))
                                  }, null, 8, ["modelValue", "onBlur", "onUpdate:modelValue"]))
                                : (!_ctx.cloze)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                      _createVNode(_component_CodeEditor, {
                                        modelValue: solution.content,
                                        "onUpdate:modelValue": ($event: any) => (_ctx.onUpdateSolution(solution.id, 'content', $event)),
                                        size: 'lg',
                                        showRunButton: true,
                                        language: _ctx.languageCode,
                                        onBlur: ($event: any) => (_ctx.onBlurSolution(solution.id)),
                                        onRun: ($event: any) => (_ctx.onTestSolution(solution.id)),
                                        running: _ctx.testingSolutions[solution.id] ?? false
                                      }, {
                                        runButton: _withCtx(() => [
                                          _hoisted_35,
                                          _createTextVNode(_toDisplayString(_ctx.testingSolutions[solution.id]
													? _ctx.$t("exercise_editor.testing_solution")
													: _ctx.$t("exercise_editor.test_solution")), 1)
                                        ]),
                                        sidePaneTitle: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_36, [
                                            _hoisted_37,
                                            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("programming_exercise.execution_results")), 1)
                                          ])
                                        ]),
                                        sidePane: _withCtx(() => [
                                          (_ctx.solutionTestSlots[solution.id]?.execution_results)
                                            ? (_openBlock(), _createBlock(_component_CodeExecutionResults, {
                                                key: 0,
                                                executionResults: 
													_ctx.solutionTestSlots[solution.id].execution_results
												,
                                                testCases: _ctx.modelValue.testcases
                                              }, null, 8, ["executionResults", "testCases"]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                _hoisted_39,
                                                _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t("exercise_editor.code_execution_will_appear_here")), 1)
                                              ]))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "language", "onBlur", "onRun", "running"])
                                    ]))
                                  : _createCommentVNode("", true),
                              _createVNode(_component_Btn, {
                                outline: true,
                                variant: 'icon',
                                class: "transition-opacity duration-100 opacity-50 hover:opacity-100",
                                onClick: ($event: any) => (_ctx.onDeleteSolution(solution.id))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_41
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createBlock(_component_SlotSkeleton, { key: 1 })),
                    _createVNode(_component_Btn, {
                      class: "mt-2",
                      variant: 'secondary',
                      size: 'sm',
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onAddSolution()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_42,
                        _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.new_solution")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.modelValue.exercise_type === _ctx.ExerciseType.JS)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createVNode(_component_Toggle, {
                      class: "",
                      modelValue: _ctx.modelValue.requires_typescript,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.onBaseExerciseChange('requires_typescript', $event)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.requires_typescript")) + " ", 1),
                        (_openBlock(), _createElementBlock("svg", _hoisted_44, _hoisted_46))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.subExercise)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createVNode(_component_TagInput, {
                      choices: _ctx.mainStore.tags,
                      modelValue: _ctx.modelValue.public_tags ?? [],
                      "allow-edit-tags": false,
                      placeholder: _ctx.$t('exercise_editor.exercise_public_tags'),
                      onAddTag: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onAddTag($event, true))),
                      onRemoveTag: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onRemoveTag($event, true)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("exercise_editor.exercise_public_tags")), 1),
                          _createVNode(_component_Tooltip, {
                            class: "transform scale-125",
                            "text-code": 'exercise_editor.public_tags'
                          }, null, 8, ["text-code"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["choices", "modelValue", "placeholder"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.subExercise)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createVNode(_component_TagInput, {
                      choices: _ctx.mainStore.tags,
                      modelValue: _ctx.modelValue.private_tags ?? [],
                      "allow-edit-tags": false,
                      placeholder: _ctx.$t('exercise_editor.exercise_private_tags'),
                      onAddTag: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onAddTag($event, false))),
                      onRemoveTag: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onRemoveTag($event, false)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("exercise_editor.exercise_private_tags")), 1),
                          _createVNode(_component_Tooltip, {
                            class: "transform scale-125",
                            "text-code": 'exercise_editor.private_tags'
                          }, null, 8, ["text-code"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["choices", "modelValue", "placeholder"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.canBeAllOrNothing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              _createVNode(_component_Toggle, {
                modelValue: _ctx.modelValue.all_or_nothing,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.onBaseExerciseChange('all_or_nothing', $event)))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("exercise_editor.all_or_nothing")), 1),
                    _createVNode(_component_Tooltip, {
                      class: "transform scale-125",
                      "text-code": 
									_ctx.isProgrammingExercise
										? 'exercise_editor.all_or_nothing_programming'
										: 'exercise_editor.all_or_nothing'
								
                    }, null, 8, ["text-code"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isMultipleChoice)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass([_ctx.cloze ? '-mt-6' : 'mt-8'])
            }, [
              _createElementVNode("h3", _hoisted_53, _toDisplayString(_ctx.$t("exercise_editor.choices_title")), 1),
              (_ctx.v$.modelValue.choices.$errors.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.modelValue.choices.$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "input-errors",
                        key: error.$uid
                      }, [
                        _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("validation_errors.exercise." + error.$uid)), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showNoChoicePenaltyWarning)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _hoisted_57,
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.no_choice_penalty_warning")) + " ", 1),
                      _createVNode(_component_ArticleHandle, { articleId: 'multiple_choice_eval_logic' }),
                      _createTextVNode(". ")
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_draggable, {
                animation: "100",
                handle: ".drag-handle",
                modelValue: _ctx.modelValue.choices,
                onEnd: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onChoiceDragEnd($event))),
                "ghost-class": "drag-ghost",
                "item-key": "id"
              }, {
                item: _withCtx(({ element }) => [
                  _createVNode(_component_ChoiceEditor, {
                    correctnessIsBoolean: 
									_ctx.modelValue.exercise_type ===
										_ctx.ExerciseType.MULTIPLE_CHOICE_MULTIPLE_POSSIBLE &&
									_ctx.modelValue.all_or_nothing
								,
                    singleLine: _ctx.cloze,
                    invalidCorrectness: !!_ctx.choicesCorrectnessError,
                    modelValue: element,
                    onDelete: ($event: any) => (_ctx.onDeleteChoice(element.id)),
                    onBlur: ($event: any) => (_ctx.onBlurChoice(element.id)),
                    onChoiceUpdate: ($event: any) => (_ctx.onUpdateChoice(element.id, $event.field, $event.value)),
                    "icon-type": 
									_ctx.cloze
										? 'dropdown'
										: _ctx.modelValue.exercise_type ===
										  _ctx.ExerciseType.MULTIPLE_CHOICE_SINGLE_POSSIBLE
										? 'radio'
										: 'checkbox'
								
                  }, null, 8, ["correctnessIsBoolean", "singleLine", "invalidCorrectness", "modelValue", "onDelete", "onBlur", "onChoiceUpdate", "icon-type"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_Btn, {
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onAddChoice())),
                size: 'sm',
                variant: 'secondary'
              }, {
                default: _withCtx(() => [
                  _hoisted_58,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("exercise_editor.new_choice")), 1)
                ]),
                _: 1
              })
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.modelValue.exercise_type === _ctx.ExerciseType.AGGREGATED)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createElementVNode("h3", _hoisted_60, _toDisplayString(_ctx.$t("exercise_editor.sub_exercises_title")), 1),
              (_ctx.v$.modelValue.sub_exercises.$errors.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.modelValue.sub_exercises.$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "input-errors",
                        key: error.$uid
                      }, [
                        _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t("validation_errors.exercise." + error.$uid)), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_draggable, {
                animation: "100",
                handle: ".drag-handle",
                modelValue: _ctx.modelValue.sub_exercises,
                onEnd: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onChoiceDragEnd($event))),
                "ghost-class": "drag-ghost",
                "item-key": "id"
              }, {
                item: _withCtx(({ element }) => [
                  _createVNode(_component_ExerciseEditor, {
                    invalidChildWeight: !!_ctx.childWeightError,
                    onDelete: ($event: any) => (_ctx.onDeleteSubExercise(element.id)),
                    subExercise: true,
                    modelValue: element
                  }, null, 8, ["invalidChildWeight", "onDelete", "modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_Btn, {
                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onAddSubExercise())),
                size: 'sm',
                variant: 'secondary'
              }, {
                default: _withCtx(() => [
                  _hoisted_63,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("exercise_editor.new_sub_exercise")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.isProgrammingExercise)
          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
              _createElementVNode("h3", _hoisted_65, _toDisplayString(_ctx.$t("exercise_editor.testcases_title")), 1),
              (_ctx.modelValue.exercise_type === _ctx.ExerciseType.JS)
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("p", _hoisted_67, [
                      _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.use_assert_lib")) + " ", 1),
                      _hoisted_68,
                      _createTextVNode(". ")
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_draggable, {
                animation: "100",
                modelValue: _ctx.modelValue.testcases,
                "ghost-class": "drag-ghost",
                handle: ".drag-handle",
                "item-key": "id"
              }, {
                item: _withCtx(({ element }) => [
                  _createVNode(_component_TestCaseEditor, {
                    attachments: 
									_ctx.mainStore.exerciseTestCaseAttachmentsByTestCaseId[element.id] ?? []
								,
                    executingSolution: _ctx.testingSomeSolution,
                    testCaseType: _ctx.modelValue.exercise_type,
                    onBlur: ($event: any) => (_ctx.onBlurTestCase(element.id)),
                    onDelete: ($event: any) => (_ctx.onDeleteTestCase(element.id)),
                    onCreateAttachment: ($event: any) => (_ctx.onTestCaseCreateAttachment(element.id, $event)),
                    onDownloadAttachment: ($event: any) => (_ctx.onTestCaseDownloadAttachment(element.id, $event)),
                    onDeleteAttachment: ($event: any) => (_ctx.onTestCaseDeleteAttachment(element.id, $event)),
                    modelValue: element,
                    executionResultsSlots: Object.values(_ctx.solutionTestSlots),
                    onTestCaseUpdate: ($event: any) => (_ctx.onUpdateTestCase(element.id, $event.field, $event.value))
                  }, null, 8, ["attachments", "executingSolution", "testCaseType", "onBlur", "onDelete", "onCreateAttachment", "onDownloadAttachment", "onDeleteAttachment", "modelValue", "executionResultsSlots", "onTestCaseUpdate"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_Btn, {
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.onAddTestCase())),
                size: 'sm',
                variant: 'secondary'
              }, {
                default: _withCtx(() => [
                  _hoisted_69,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("exercise_editor.new_testcase")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.modelValue.exercise_type === _ctx.ExerciseType.COMPLETION)
          ? (_openBlock(), _createBlock(_component_Dialog, {
              key: 6,
              fullWidth: true,
              confirmOnly: true,
              onYes: _cache[27] || (_cache[27] = ($event: any) => (_ctx.editingClozeSubExerciseId = null)),
              showDialog: !!_ctx.editingCloze
            }, _createSlots({
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.editing_cloze")) + " " + _toDisplayString(_ctx.modelValue.sub_exercises?.findIndex(
								s => s.id == _ctx.editingClozeSubExerciseId,
							) + 1), 1)
              ]),
              _: 2
            }, [
              (!!_ctx.editingCloze)
                ? {
                    name: "body",
                    fn: _withCtx(() => [
                      _createVNode(_component_ExerciseEditor, {
                        modelValue: _ctx.editingCloze,
                        subExercise: true,
                        cloze: true,
                        invalidChildWeight: !!_ctx.childWeightError
                      }, null, 8, ["modelValue", "invalidChildWeight"])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["showDialog"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Dialog, {
          showDialog: _ctx.showDialog,
          onYes: _cache[28] || (_cache[28] = ($event: any) => (_ctx.dialogData.onYes())),
          onNo: _cache[29] || (_cache[29] = ($event: any) => (_ctx.dialogData.onNo())),
          yesText: _ctx.dialogData.yesText,
          noText: _ctx.dialogData.noText,
          error: _ctx.dialogData.error,
          confirmOnly: _ctx.dialogData.confirmOnly
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.dialogData.title), 1)
          ]),
          body: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.dialogData.text) + " ", 1),
            (_ctx.v$.modelValue.$errors)
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _createElementVNode("ul", _hoisted_71, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.$errors, (error, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "text-muted text-danger-dark",
                        key: 'err-' + index
                      }, _toDisplayString(_ctx.$t("validation_errors.exercise." + error.$uid)), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["showDialog", "yesText", "noText", "error", "confirmOnly"]),
        _createElementVNode("div", _hoisted_72, [
          (_ctx.maxScore !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t("exercise_editor.max_score")), 1),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.maxScore), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.subExercise)
            ? (_openBlock(), _createBlock(_component_Btn, {
                key: 1,
                style: {"margin-top":"1px"},
                class: "ml-auto",
                outline: true,
                size: 'lg',
                variant: 'icon',
                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.$emit('cloneExercise'))),
                tooltip: _ctx.$t('exercise_editor.clone')
              }, {
                default: _withCtx(() => [
                  _hoisted_76
                ]),
                _: 1
              }, 8, ["tooltip"]))
            : _createCommentVNode("", true),
          (!_ctx.subExercise)
            ? (_openBlock(), _createBlock(_component_Btn, {
                key: 2,
                class: "ml-5",
                outline: true,
                size: 'lg',
                variant: 'icon',
                tooltip: _ctx.$t('exercise_editor.delete'),
                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.$emit('delete')))
              }, {
                default: _withCtx(() => [
                  _hoisted_77
                ]),
                _: 1
              }, 8, ["tooltip"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["loading", "focusable", "borderLess", "filled", "class"])
  ]))
}